<p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

<app-page-shell>
  <app-page-hero eyebrow="Container Tracking Setup" [title]="title" [subtitle]="subtitle">
    <div actions>
      <p-button label="Back To Setup" icon="pi pi-arrow-left" severity="secondary" [outlined]="true" routerLink="/container-tracking/setup"></p-button>
      <p-button *ngIf="canAdd" label="New" icon="pi pi-plus" [routerLink]="addRoute"></p-button>
    </div>
  </app-page-hero>

  <app-page-metric-strip [metrics]="metrics"></app-page-metric-strip>

  <app-page-data-panel [title]="title" subtitle="Search, review, and open records in dedicated form pages." [resultText]="master === 'facilities' ? filteredFacilities.length + ' facilities' : master === 'areas' ? filteredAreas.length + ' areas' : master === 'slots' ? filteredSlots.length + ' slots' : master === 'charge-rules' ? filteredChargeRules.length + ' rules' : catalogRows.length + ' values'">
    <div class="setup-filter-grid">
      <p-iftaLabel>
        <input id="setupKeyword" pInputText [(ngModel)]="keyword">
        <label for="setupKeyword">Search</label>
      </p-iftaLabel>
      <p-iftaLabel *ngIf="master !== 'facilities' && master !== 'execution-values'">
        <p-select inputId="setupFacility" [options]="facilities" optionLabel="facilityName" optionValue="id" [(ngModel)]="facilityFilter" [filter]="true" [showClear]="true" styleClass="w-full"></p-select>
        <label for="setupFacility">Facility</label>
      </p-iftaLabel>
      <p-iftaLabel *ngIf="master !== 'execution-values'">
        <p-select inputId="setupActive" [options]="activeOptions" optionLabel="label" optionValue="value" [(ngModel)]="activeFilter" styleClass="w-full"></p-select>
        <label for="setupActive">Status</label>
      </p-iftaLabel>
      <p-button label="Clear" icon="pi pi-filter-slash" severity="secondary" [outlined]="true" (click)="clearFilters()"></p-button>
    </div>

    <p-table *ngIf="master === 'facilities'" [value]="filteredFacilities" styleClass="p-datatable-sm">
      <ng-template pTemplate="header"><tr><th>Code</th><th>Name</th><th>Type</th><th>Mode</th><th>CRM Supplier</th><th>Warehouse Link</th><th>Status</th><th class="text-right">Actions</th></tr></ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td><code>{{ row.facilityCode || '-' }}</code></td>
          <td>{{ row.facilityName || '-' }}</td>
          <td>{{ typeLabel(row.facilityType) }}</td>
          <td><p-tag [value]="row.operationMode === 'REFERENCE_ONLY' ? 'Reference only' : 'Managed yard'" [severity]="row.operationMode === 'REFERENCE_ONLY' ? 'warn' : 'success'"></p-tag></td>
          <td>{{ supplierName(row.operatorCrmClientId) }}</td>
          <td>{{ warehouseName(row.linkedWarehouseId) }}</td>
          <td><p-tag [value]="row.active === false ? 'Inactive' : 'Active'" [severity]="row.active === false ? 'secondary' : 'success'"></p-tag></td>
          <td class="text-right"><p-button icon="pi pi-pencil" [text]="true" severity="secondary" [routerLink]="editRoute(row.id)" pTooltip="Edit facility"></p-button></td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage"><tr><td colspan="8"><div class="table-empty">No facilities found.</div></td></tr></ng-template>
    </p-table>

    <p-table *ngIf="master === 'areas'" [value]="filteredAreas" styleClass="p-datatable-sm">
      <ng-template pTemplate="header"><tr><th>Code</th><th>Name</th><th>Facility</th><th>Type</th><th>Capabilities</th><th>Status</th><th class="text-right">Actions</th></tr></ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td><code>{{ row.areaCode || '-' }}</code></td>
          <td>{{ row.areaName || '-' }}</td>
          <td>{{ facilityName(row.facilityId) }}</td>
          <td>{{ typeLabel(row.areaType) }}</td>
          <td>
            <p-tag *ngIf="row.reeferSupported" value="Reefer" severity="info"></p-tag>
            <p-tag *ngIf="row.customsControlled" value="Customs" severity="warn"></p-tag>
            <p-tag *ngIf="row.hazardousAllowed" value="Haz" severity="danger"></p-tag>
          </td>
          <td><p-tag [value]="row.active === false ? 'Inactive' : 'Active'" [severity]="row.active === false ? 'secondary' : 'success'"></p-tag></td>
          <td class="text-right"><p-button icon="pi pi-pencil" [text]="true" severity="secondary" [routerLink]="editRoute(row.id)" pTooltip="Edit area"></p-button></td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage"><tr><td colspan="7"><div class="table-empty">No yard areas found.</div></td></tr></ng-template>
    </p-table>

    <p-table *ngIf="master === 'slots'" [value]="filteredSlots" styleClass="p-datatable-sm">
      <ng-template pTemplate="header"><tr><th>Slot</th><th>Facility</th><th>Area</th><th>Layout</th><th>Capacity</th><th>Compatibility</th><th>Status</th><th class="text-right">Actions</th></tr></ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td><strong>{{ row.slotCode || '-' }}</strong></td>
          <td>{{ facilityName(row.facilityId) }}</td>
          <td>{{ areaName(row.areaId) }}</td>
          <td>{{ row.blockCode || '-' }}/{{ row.rowCode || '-' }}/{{ row.bayCode || '-' }}/{{ row.tierCode || '-' }}</td>
          <td>{{ row.maxTeuCapacity || 1 }} TEU</td>
          <td>{{ row.allowedContainerTypes || 'All container types' }}</td>
          <td><p-tag [value]="row.active === false ? 'Inactive' : 'Active'" [severity]="row.active === false ? 'secondary' : 'success'"></p-tag></td>
          <td class="text-right"><p-button icon="pi pi-pencil" [text]="true" severity="secondary" [routerLink]="editRoute(row.id)" pTooltip="Edit slot"></p-button></td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage"><tr><td colspan="8"><div class="table-empty">No yard slots found.</div></td></tr></ng-template>
    </p-table>

    <p-table *ngIf="master === 'charge-rules'" [value]="filteredChargeRules" styleClass="p-datatable-sm">
      <ng-template pTemplate="header"><tr><th>Service / Charge</th><th>Facility</th><th>Area</th><th>Basis</th><th>Free Days</th><th>Rate</th><th>Status</th><th class="text-right">Actions</th></tr></ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>
            <strong>{{ productName(row.productId) }}</strong>
            <div class="muted">{{ productCode(row.productId) || typeLabel(row.chargeType) }} · {{ typeLabel(row.chargeType) }}</div>
            <div class="muted">{{ row.containerType || 'All container types' }}</div>
          </td>
          <td>{{ facilityName(row.facilityId) }}</td>
          <td>{{ areaName(row.areaId) }}</td>
          <td>{{ typeLabel(row.chargeBasis) }}</td>
          <td>{{ row.freeDays || 0 }}</td>
          <td>{{ row.currencyCode || 'SAR' }} {{ (row.rateAmount || 0) | number:'1.2-2' }}</td>
          <td><p-tag [value]="row.active === false ? 'Inactive' : 'Active'" [severity]="row.active === false ? 'secondary' : 'success'"></p-tag></td>
          <td class="text-right"><p-button icon="pi pi-pencil" [text]="true" severity="secondary" [routerLink]="editRoute(row.id)" pTooltip="Edit charge rule"></p-button></td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage"><tr><td colspan="8"><div class="table-empty">No yard charge rules found.</div></td></tr></ng-template>
    </p-table>

    <p-table *ngIf="master === 'execution-values'" [value]="catalogRows" styleClass="p-datatable-sm">
      <ng-template pTemplate="header"><tr><th>Code</th><th>Label</th><th>Category</th><th>Meaning</th></tr></ng-template>
      <ng-template pTemplate="body" let-row>
        <tr><td><code>{{ row.code }}</code></td><td>{{ row.label }}</td><td>{{ row.category || '-' }}</td><td>{{ row.description }}</td></tr>
      </ng-template>
      <ng-template pTemplate="emptymessage"><tr><td colspan="4"><div class="table-empty">No execution values found.</div></td></tr></ng-template>
    </p-table>
  </app-page-data-panel>
</app-page-shell>
